<div [ngClass]="hide ? 'hidden' : ''" attr.data-col="{{this.col}}">
  <label>{{this.label}}</label>
  <div class="form-control">
    <div class="col-7 fileDiv">
      <span #fileName>Nessun file selezionato</span>
    </div>
    <div class="col-3 uploadBtn {{this.class}}">
      <span (click)="onFileOpen($event)">Carica</span>
      <input (change)="onFileUploaded($event)" #inputField class="form-control {{this.class}}" type="file" accept="application/pdf" placeholder="{{this.placeholder}}" name="{{this.name}}" id="{{this.id}}" />
    </div>
    <div class="col-2 deleteBtn {{this.class}}">
      <span (click)="clearFile()">X</span>
    </div>
  </div>
</div>